<!--
 * @Description:
 * @Author: kangkang
 * @Date: 2022-08-08 17:23:56
 * @LastEditTime: 2023-04-13 01:03:35
 * @LastEditors: kangkang
 * @Reference:
-->
<template>
    <div class="order">
        <div class="order-list" v-if="listArr.length > 0">
            <div
                class="list"
                v-for="(item,index) in listArr"
                :key="index"
            >
                <div class="list-mess">
                    <div class="serial">
                        订单号: {{ item.order_num }}
                    </div>
                    <div class="time">
                        付款时间: {{ item.pay_time }}
                    </div>
                </div>
                <div class="list-money">&yen;{{ item.pay_amt }}</div>
            </div>
        </div>
        <div class="no-data" v-else>
            <img class="no-data-img" src="../../assets/order-nodata.png" alt=""/>
            <div class="text">暂无相关订单信息…</div>
        </div>
    </div>
</template>
<script>
export default {
    name: "order",
    data() {
        return {
            listArr: []
        };
    },
    components: {},
    computed: {},
    methods: {
       getList() {
           this.$utils.checkToken().then(res=>{
               this.$api.index.orderLists().then(res => {
                   this.listArr = res;
               })
           })
       }
    },

    mounted() {
        this.getList();
    },
    created() {

    },
    watch: {
    },
};
</script>
<style rel="stylesheet/scss" lang="scss">
// .van-pull-refresh {
//     height: 100vh;
// }
.van-loading {
    margin: 0 auto;
    width: px2rem(200);
}
.van-popup {
    background: inherit;
}

.order {
    width: 100%;
    min-height: 100%;
    background: #F4F4F4;
    .no-data {
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        &-img {
            display: block;
            width: px2rem(240);
            height: px2rem(240);
            margin-top: px2rem(126);
        }
        .text {
            text-align: center;
            font-size: px2rem(28);
            color: #808080;
            margin-top: px2rem(20);
        }
    }
    &-list {
        overflow: hidden;
        .list {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            height: px2rem(156);
            box-sizing: border-box;
            padding: 0 px2rem(24);
            background: #ffffff;
            font-size: px2rem(30);
            color: #000000;
            margin-top: px2rem(20);
            overflow: hidden;
            &-mess {
                .time {
                    font-size: px2rem(24);
                    color: #808080;
                    margin-top: px2rem(12);
                }
            }
            &-money {
                font-size: px2rem(36);
                color: #A88E6E;
            }
        }
    }

}
</style>
